import React, { useEffect } from "react";
import { Route, useLocation, Routes, Navigate } from "react-router-dom";
import SubscriptionRequests from "./requests/SubscriptionRequests";
import SubscriptionPortalFinance from "./finance/SubscriptionPortalFinance";
import SubscriptionOverview from "./overview/SubscriptionOverview";
import MspSubscriptionAccounts from "./mspAccountsSubscription/MspSubscriptionAccounts";
import MspSubscriptionAccountDetails from "./mspAccountsSubscription/MspSubscriptionAccountDetails";
import MspArchivedAccounts from "./mspAccountsSubscription/MspArchivedAccounts";
import useGetCustomerInfo from "../../hooks/get-customer-info.hook";
import { APP_ROUTES } from "../../constants/app.constants";
import SideNav from "../SideNav/SideNav";
import Header from "./Header";
import "./index.styles.scss";
import SecStackReportRoutes from "./sec-stack-report.routes";
import SubscriptionPortalRoutes from "./subscription-portal.routes";
import DistributorSettingsRoutes from "./distributor-settings.routes";
import HgSettingsRoutes from "./hg-settings.routes";

const SubscriptionBackendHome = () => {
  const location = useLocation();
  const currentUrl = location.pathname;
  const accountId = currentUrl.split('/')[3];
  const { data, isLoading, getCustomerInfo } = useGetCustomerInfo();

  useEffect(() => {
    getCustomerInfo(accountId);
  }, [accountId])

  return (
    <div className="subscription-backend-portal-wrapper">
      <div
        className="fullHeight sideNav hide-scrollbar"
        style={{
          overflowY: `auto`,
        }}
      >
        <div
          className={``}
          style={{ height: "100%" }}
        >
          <SideNav />
        </div>
      </div>
      <Routes>
        <Route path={`${APP_ROUTES.subscriptionPortalPages.secStackReport}/*`} element={<SecStackReportRoutes />} />
        <Route path={`${APP_ROUTES.subscriptionPortalPages.distributorSettings}/*`} element={<DistributorSettingsRoutes />} />
        <Route path={`${APP_ROUTES.subscriptionPortalPages.hgSettings}/*`} element={<HgSettingsRoutes />} />
        <Route 
          path="*" 
          element={<SubscriptionPortalRoutes isLoading={isLoading} accountId={accountId} data={data} />} 
        />
      </Routes>
    </div>
  );
};

export default SubscriptionBackendHome;
